import isNil from 'lodash/isNil'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { useUpdateTableFilter } from '../../table-filters/useUpdateTableFilter'
import { TableFilter } from '../components/SavedFiltersButton'

export const useUpdateSavedFilter = () => {
  const { t } = useTranslation('requests')
  const { user } = useAuthenticatedUser()
  const { enqueueSnackbar } = useSnackbar()

  const { mutateAsync: updateTableFilterMutation } = useUpdateTableFilter()

  const updateSavedFilter = async (editingFilter: TableFilter, updates: Partial<TableFilter>) => {
    const id = editingFilter.id
    const tableFilter: Partial<TableFilter> = { ...updates }

    const isAllowedToUpdateVisibility = user.isAdmin && editingFilter.userId === user.id
    if (!isAllowedToUpdateVisibility) {
      delete tableFilter.isPublic
    }

    try {
      const result = await updateTableFilterMutation({
        body: tableFilter,
        pathParams: { id },
      })

      if (isNil(result?.id)) {
        enqueueSnackbar(t('create-user-request-filter.dialog.update-error'), { variant: 'error' })
        return false
      }

      enqueueSnackbar(t('create-user-request-filter.dialog.update-success'), { variant: 'success' })
      return true
    } catch (error) {
      console.error('Failed to update table filter', { error, id, updates })
      enqueueSnackbar(t('create-user-request-filter.dialog.update-error'), { variant: 'error' })
      return false
    }
  }

  return updateSavedFilter
}
